import React from 'react';
import { Popup, PopupWrapper } from '@sunbit-dev/purchase-common/src/components/popup/Popup';
import styled from 'styled-components';
import { WhiteBackground } from '~/components/HealthcareLandingModal/components/whiteBackground/WhiteBackground';
import { Content } from './components/content/Content';
import { HealthcareLandingPageProps } from '~/components/HealthcareLandingModal/models';

const SPopup = styled(Popup)(
  ({ theme }) => `
    padding: 0;
  `
);

const SContainer = styled.div(
  ({ theme }) => `
    position: relative;
    width: 100%;
    height: 100%;

    @media only screen and ${theme.device.laptopM} {
      height: 663px;
      width: 1312px;
    }

    @media only screen and ${theme.device.max.laptopM} and ${theme.device.tablet} {
      height: 848px;
      width: 656px;
    }
    `
);

const SWhiteBackground = styled(WhiteBackground)(
  () => `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 20px;
`
);

const SContentWrapper = styled.div(
  () => `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  border-radius: 20px;
`
);

const HealthcareLandingModal = ({ isOpen, className }: HealthcareLandingPageProps) => {
  if (!isOpen) return null;

  return (
    <div className={className}>
      <PopupWrapper fullScreenOnMobile>
        <SPopup>
          <SContainer>
            <SWhiteBackground />
            <SContentWrapper>
              <Content />
            </SContentWrapper>
          </SContainer>
        </SPopup>
      </PopupWrapper>
    </div>
  );
};

export default HealthcareLandingModal;
